import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IApiOrganizationUserRole } from '~/lib/api/modules/Organizations';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { OrganizationUserFormMainSection } from './OrganizationUserFormMainSection';

export type IOrganizationUserFormValues = {
  email?: string;
  role?: IApiOrganizationUserRole;
};

export type IOrganizationUserFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IOrganizationUserFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<IOrganizationUserFormValues>;
    onSubmit?: SubmitHandler<IOrganizationUserFormValues>;
  };

export const OrganizationUserForm: React.FC<IOrganizationUserFormProps> = (
  props,
) => {
  const { sx, mode, defaultValues, onSubmit, ...other } = props;
  const form = useForm<IOrganizationUserFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <OrganizationUserFormMainSection form={form} mode={mode} />
    </ContentBlock.FormBody>
  );
};
